/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: TrainingPage
 * Page name: Training page
 * Page Description: This is the Training page of the website of Ekathva Innovations.
 */

import React,{ Component } from 'react'
import MetaTags from 'react-meta-tags'
import {Col, Row, Container, Button, Modal, Dropdown, Media, Card } from 'react-bootstrap';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import InternshipImage from "assets/images/OurProducts/QuestLearn.png";

import { Formik, Form } from 'formik';
import Validation from '../Validation.js';
import ApiService from '../api/ApiService.js';

import { Input } from 'reactstrap';
import { Link } from "react-router-dom";

import 'assets/style/Style.css'
import successImage from 'assets/images/AllPage/list.png';
import failureImage from 'assets/images/AllPage/into.png';

import Navbar from 'components/Navbars/Navbar'
import LandingPageMedia from 'components/Headers/LandingPageTraining'
import Footer from 'components/Footers/Footer'

import {ReactComponent as ED1} from "assets/images/EmbeddedService/ED1.svg"
import {ReactComponent as ED2} from "assets/images/EmbeddedService/ED2.svg"
import {ReactComponent as ED3} from "assets/images/EmbeddedService/ED3.svg"
import {ReactComponent as ED4} from "assets/images/EmbeddedService/ED4.svg"
import {ReactComponent as ED5} from "assets/images/EmbeddedService/ED6.svg"
import {ReactComponent as ED6} from "assets/images/EmbeddedService/ED5.svg"
import {ReactComponent as ED7} from "assets/images/EmbeddedService/ED7.svg"
import {ReactComponent as Points} from "assets/images/EmbeddedService/Points.svg"

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

class TrainingPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      modal_internship: false,
      modal_success: false,
      modal_failure: false,
      name: "",
      emailAddress: "",
      contactNumber: "",
      collegeName: "",
      city: "",
      requirement: ""
              }

    this.onTrainingSubmit = this.onTrainingSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.toggle = this.toggle.bind(this);
  };

  componentDidMount() {
    // this is needed, because InfiniteCalendar forces window scroll
    window.scrollTo(0, 0);
  }

  toggle = modalType => () => {
    console.log("inside toggle");
    if (!modalType) { return this.setState({ modal: !this.state.modal }); }
    this.setState({ [`modal_${modalType}`]: !this.state[`modal_${modalType}`] });
  };

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    let value = event.target.value
    this.setState({ [name]: value});
  }

  onKeyPressTextOnly(event) {
    if(event.charCode !== 32){ Validation.onKeyPressTextOnly(event); }
  }
  onKeyPressNumberOnly(event){
    if(event.charCode !== 32){ Validation.onKeyPressNumberOnly(event);  }
  }
  onKeyPressRetrisctSomeSC(event){
  if(event.charCode !== 32){ Validation.onKeyPressRetrisctSomeSC(event);  }
  }

  camelCaseString(string){

  let words = string.trim().split(" ");

  let result = "";

  for(let i=0; i < words.length; i++){
    if(words[i] !== ""){
      result = result + " " +words[i][0].toUpperCase() + words[i].substring(1).toLowerCase();
    }
  }

  return result;

  }

  onTrainingSubmit(values) {

    console.log(values);


      let fields = {
        name: this.camelCaseString(values.name),
        emailAddress: values.emailAddress,
        contactNumber: values.contactNumber,
        collegeName: this.camelCaseString(values.collegeName),
        city: this.camelCaseString(values.city),
        requirement: values.requirement
      }


      ApiService.createTraining(fields)
      .then((response) =>{
        this.setState({
          modal_success: !this.state.modal_success,
          message: "We have received your Requirement! We will get back to you soon."
        })
      }).catch((error) =>{
        this.setState({
          modal_failure: !this.state.modal_failure,
          message: "Something Went Wrong! Please Try Again"
        })
      })
    }


    refresh(event) {
      window.location.reload()
    }

    render() {
      let {name, emailAddress, contactNumber, collegeName, city, requirement} = this.state

      return (
          <div>
          <MetaTags>
              <title>Training and Internships - IT, Embedded system, IoT, Web Development Trainings, Workshops, Internships in shivamogga| Ekathva Innovations Pvt Ltd</title>
          </MetaTags>



          <Navbar/>
          <LandingPageMedia/>

          {/* <div className="internship_banner">
              <h2>
              <strong>
              <em>Internship-2023</em>
              </strong>
              </h2>
              <Link onClick={this.toggle('internship')} class="cta1" style={{ textDecoration: 'none' }}>
              <span>View Details</span>
              <svg width="13px" height="10px" viewBox="0 0 13 10">
              <path d="M1,5 L11,5"></path>
              <polyline points="8 1 12 5 8 9"></polyline>
              </svg>
              </Link>
          </div>
          <br/> */}


          <div className="aboutus_mainspace" >
              <p className="training_headingfont" >Trainings and upskillings:</p>

              <p className="training_contentfont" >
                  <strong>
                      <span className="aboutus_fontsitallic" >
                          Create a Better Version of yourself by being a part of the training and
                          knowledge sharing we offer!
                          <br/><br/>
                      </span>
                    We at Ekathva offers trainings, knowledge sharing, internships on Trending technologies with hands-on approach.
                      We focus on upskilling, knowledge sharing, and conducting the workshops, trainings at an affordable cost for a student.
                  </strong>
              </p>

              <p className="training_font" >
                  So far, EI and its expert team have trained 1000+ young minds through various training programs conducted accross Karnataka.
              </p>

              <Row className="training_dotpadding" >
                  <Col><span class="dot"><p className="training_dotspacing" ><strong><br/>800+<br/> students</strong></p></span></Col>
                  <Col><span class="dot"><p className="training_dotspacing" ><strong><br/>30+ <br/>workshops</strong></p></span></Col>
                  <Col><span class="dot"><p className="training_dotspacing" ><strong><br/>180+<br/> interns</strong></p></span></Col>
              </Row>
              <br/><br/>
              <Row>
                  <Col>
                  <p className="training_colpadding" >
                      <strong>
                          Workshops/Hands-On trainings offered in the fields of trending technology:
                          <br/><br/>
                          <ul className="training_display" >
                            <Media>
                              <ED7 className="align-self-start mr-3 svgcolor training_logo " />
                              <Media.Body>
                                Embedded Systems, Microcontrollers with Arduino UNO
                              </Media.Body>
                            </Media>

                            <Media>
                            <ED6 className="align-self-start mr-3  svgcolor training_logo " />
                              <Media.Body>
                              Internet of Things and Building Smart things for home/industry
                              </Media.Body>
                            </Media>

                            <Media>
                              <ED2 className="align-self-start mr-3 svgcolor training_logo " />
                              <Media.Body>
                              PCB designing
                              </Media.Body>
                            </Media>

                            <Media>
                              <ED4 className="align-self-start mr-3 svgcolor training_logo " />
                              <Media.Body>
                              Robotics and Automation
                              </Media.Body>
                            </Media>

                            <Media>
                              <ED1 className="align-self-start mr-3 svgcolor training_logo " />
                              <Media.Body>
                              Website Design and Development
                              </Media.Body>
                            </Media>

                            <Media>
                              <ED3 className="align-self-start mr-3 svgcolor training_logo " />
                              <Media.Body>
                                Mobile Application Development
                              </Media.Body>
                            </Media>
                          </ul>
                      </strong>
                      <ul className="training_display1" >
                        <li><p><strong>Embedded Systems, Microcontrollers with Arduino UNO </strong></p></li>
                        <li><p><strong>Internet of Things and Building Smart things for home/industry  </strong></p></li>
                        <li><p><strong>PCB designing</strong></p></li>
                        <li><p><strong>Robotics and Automation</strong></p></li>
                        <li><p><strong>Website Design and Development </strong></p></li>
                        <li><p><strong>Mobile Application Development</strong></p></li>
                      </ul>
                  </p>
                  </Col>
                  <Col>
                  <p className="training_colpadding" >
                      <strong>
                          Internships offered in the fields of advance technology:
                          <br/><br/>
                          <ul className="training_display" >
                            <Media>
                              <ED7 className="align-self-start mr-3 svgcolor training_logo " />
                              <Media.Body>
                              Embedded systems
                              </Media.Body>
                            </Media>


                            <Media>
                              <ED3 className="align-self-start mr-3 svgcolor training_logo " />
                              <Media.Body>
                              PCB designing and fabrication
                              </Media.Body>
                            </Media>


                            <Media>
                              <ED5 className="align-self-start mr-3 svgcolor training_logo " />
                              <Media.Body>
                              IoT-Internet of Things
                              </Media.Body>
                            </Media>


                            <Media>
                              <ED1 className="align-self-start mr-3 svgcolor training_logo " />
                              <Media.Body>
                              Full-stack development
                              </Media.Body>
                            </Media>


                            <Media>
                              <ED6 className="align-self-start mr-3 svgcolor training_logo " />
                              <Media.Body>
                              Web development
                              </Media.Body>
                            </Media>


                            <Media>
                              <ED4 className="align-self-start mr-3 svgcolor training_logo " />
                              <Media.Body>
                              Mobile Application development
                              </Media.Body>
                            </Media>


                            <Media>
                              <ED2 className="align-self-start mr-3 svgcolor training_logo " />
                              <Media.Body>
                              Software Development
                              </Media.Body>
                            </Media>
                          </ul>
                      </strong>
                      <ul className="training_display1" >
                        <li><p><strong>Embedded systems</strong></p></li>
                        <li><p><strong>PCB designing and fabrication</strong></p></li>
                        <li><p><strong>IoT-Internet of Things</strong></p></li>
                        <li><p><strong>Full-stack development</strong></p></li>
                        <li><p><strong>Web development</strong></p></li>
                        <li><p><strong>Mobile Application development </strong></p></li>
                        <li><p><strong>Software Development </strong></p></li>
                      </ul>
                  </p>
                  </Col>

              </Row>
              <br/><br/>

        {/*      <p><strong>Feedback</strong></p>
              <Carousel
              autoPlay={true}
              responsive={responsive}
              infinite={true}
              autoPlaySpeed={2500}>
                <Row className="training_feedbackspacing">
                  <Col>Name: abc</Col>
                  <Col xs={8}>The training was very interactive which helped us to clear doubts during the session itself! </Col>
                </Row>
                <Row className="training_feedbackspacing">
                  <Col>Name: abc</Col>
                  <Col xs={8}>The whole course is very useful as it is completely application based and hand-on. And especially the support by the trainer is excellent.</Col>
                </Row>
                <Row className="training_feedbackspacing">
                  <Col>Name: abc</Col>
                  <Col xs={8}>Great course for the basic learners. Good session and teaching</Col>
                </Row>
                <Row className="training_feedbackspacing">
                  <Col>Name: bcd</Col>
                  <Col xs={8}>I Learned about IoT which added a new experience in excelling the learning skills. As an intern here at Ekathva it was good enough to develop some excellent skills </Col>
                </Row>
                <Row className="training_feedbackspacing">
                  <Col>Name: bcd</Col>
                  <Col xs={8}>Trainers were very friendly and explained every concept from scratch. I carried out the project without any fear! </Col>
                </Row>
                <Row className="training_feedbackspacing">
                  <Col>Name: bcd</Col>
                  <Col xs={8}>Trainers taught very well, from beginning to end of the session. I learnt a lot about HTML, CSS, Angular Framework and many web development concepts </Col>
                </Row>
                <Row className="training_feedbackspacing">
                  <Col>Name: bcd</Col>
                  <Col xs={8}>I have learnt how to develop an android app and this workshop has been very useful to all of us. Thank you team Ekathva! </Col>
                </Row>
                <Row className="training_feedbackspacing">
                  <Col>Name: bcd</Col>
                  <Col xs={8}>The session was very helpful, interesting and knowledgeable. Also, the content provided was of perfect use and value to us. </Col>
                </Row>
              </Carousel>
              */}

              <div>
                <br/><hr/>
                  <h3 className="aboutus_textalign" >Get in Touch</h3>
                  <br/>
                  <div className="successstories_formspacing" >
                  <Formik
                  onSubmit={this.onTrainingSubmit}
                  initialValues={{name, emailAddress, contactNumber, collegeName, city, requirement}}
                  validateOnChange={false}
                  validateOnBlur={false}
                  enableReinitialize={true}
                  onChange={this.handleChange}>

                  <Form>
                  <Row>
                  <Col md={2}>
                  <label>Name<span className="register_page_marker">*</span></label>
                  </Col>
                  <Col md={4}>
                  <Input  className="capitalize"
                  name="name" type="text"
                  onKeyPress={event => {this.onKeyPressTextOnly(event)}}
                  onChange={this.handleChange}
                  placeholder="Enter Your Name"
                  minLength="2" maxLength="200" required />
                  </Col>
                  </Row>
                  <br />
                  <Row>
                  <Col md={2}>
                  <label>Contact Number<span className="register_page_marker">*</span></label>
                  </Col>
                  <Col md={4} className="text-center">
                  <Input
                  name="contactNumber" type="text"
                  minLength="10" maxLength="10"
                  placeholder="Enter Your Contact Number"
                  onChange={this.handleChange}
                  onKeyPress={event => {this.onKeyPressNumberOnly(event)}}
                  required />
                  </Col>
                  <Col md={2} >
                  <label>Email Address<span className="register_page_marker">*</span></label>
                  </Col>
                  <Col md={4} className="text-center">
                  <Input
                  name="emailAddress" type="email"
                  onChange={this.handleChange}
                  placeholder="Enter Your Email"
                  onKeyPress={event => {this.onKeyPressRetrisctSomeSC(event)}}
                  maxLength="200" minLength="10" required />
                  </Col>
                  </Row>
                  <br />
                  <Row>
                  <Col md={2}>
                  <label>College Name<span className="register_page_marker">*</span></label>
                  </Col>
                  <Col md={4} className="text-center">
                  <Input  className="capitalize"
                  name="collegeName" type="text"
                  onKeyPress={event => {this.onKeyPressTextOnly(event)}}
                  onChange={this.handleChange}
                  placeholder="Enter Your College Name"
                  minLength="2" maxLength="200" required />
                  </Col>
                  <Col md={2} >
                  <label>City<span className="register_page_marker">*</span></label>
                  </Col>
                  <Col md={4} className="text-center">
                  <Input  className="capitalize"
                  name="city" type="text"
                  onKeyPress={event => {this.onKeyPressTextOnly(event)}}
                  onChange={this.handleChange}
                  placeholder="Enter Your City Name"
                  minLength="2" maxLength="200" required />
                  </Col>
                  </Row>
                  <br />
                  <Row>
                  <Col md={10} >
                  <label>What you want to attend/your organization wants us to organize! Write to us:<span className="register_page_marker">*</span></label>
                  </Col>
                  </Row>
                  <Row>
                  <Col md={12} className="text-center">
                  <Input placeholder="Enter Your Requirement" name="requirement"
                  maxLength="200"
                  type="textarea" rows="2" onChange={this.handleChange}
                  onKeyPress={event => {this.onKeyPressRetrisctSomeSC(event)}}
                  required />
                  </Col>
                  </Row>

                  <Row>

                  <Col  md={2} >
                  <Button variant="outline-danger" type="submit">Submit</Button>
                  </Col>
                  <Col  md={2} >
                  <Button variant="outline-secondary" type="button" onClick={this.refresh}>Clear</Button>
                  </Col>
                  </Row>
                  </Form>

                  </Formik>

                  </div>
              </div>

          </div>
          <br/>


          {/* <Modal
          show={this.state.modal_internship} backdrop='static'
          className="modal_alert">
          <Modal.Header>
            <Button type="button" onClick={this.toggle('internship')}>X</Button>
          </Modal.Header>
          <br/>
          <br/>
          <Modal.Body className="modalBody">
          <div className="aboutus_textalign">

          <div>
          <img src={InternshipImage} alt="Smart Valve Controller" width="100%" />
          </div>
          <br/>
          <div className="internship_modal" align="center">
          <a href="https://drive.google.com/file/d/1R2cjmQuPS6v35bTTb2Jni1oGvMvJEsC-/view?usp=sharing" target="_blank" class="cta2" style={{ textDecoration: 'none' }}>
          <span className="fontSize">View Details</span>
          <svg width="13px" height="10px" viewBox="0 0 13 10">
          <path d="M1,5 L11,5"></path>
          <polyline points="8 1 12 5 8 9"></polyline>
          </svg>
          </a>
          <a href="https://forms.gle/noWvaHXy6VMtwb2Z9" target="_blank" class="cta2" style={{ textDecoration: 'none' }}>
          <span className="fontSize">Register Here</span>
          <svg width="13px" height="10px" viewBox="0 0 13 10">
          <path d="M1,5 L11,5"></path>
          <polyline points="8 1 12 5 8 9"></polyline>
          </svg>
          </a>
          <br/>
          </div>

          </div>
          <br/>
            </Modal.Body>
          </Modal> */}



          {/*Success Modal */}
                <Modal
                show={this.state.modal_success} backdrop='static'
                className="modal_alert">
                <Modal.Body className="modalBody">
                <div className="aboutus_textalign">
                <img src={successImage} width="8%"  alt="ekathvainnovations.com"></img>
                <br/>
                <br/>
                <h4 className="aboutus_textalign"><strong> Success! </strong></h4>
                <br/>
                <br/>
                <h6 className="aboutus_textalign">{this.state.message}</h6>
                <br/>
                <Button type="button" variant="outline-danger" onClick={this.toggle('success')}>OK</Button>
                </div>
                <br/>
                  </Modal.Body>
                </Modal>

                {/*Failure Modal */}
                <Modal
                show={this.state.modal_failure} backdrop='static'
                className="modal_alert">
                <Modal.Body className="modalBody">
                <div className="aboutus_textalign">
                <img src={failureImage} width="8%"  alt="ekathvainnovations.com"></img>
                <br/>
                <br/>
                <h4 className="aboutus_textalign"><strong> Failure! </strong></h4>
                <br/>
                <br/>
                <h6 className="aboutus_textalign">{this.state.message}</h6>
                <br/>
                <Button type="button" variant="outline-danger" onClick={this.toggle('failure')}>OK</Button>
                </div>
                <br/>
              </Modal.Body>
                </Modal>

          <Footer/>
          </div>
      )

      }

}
export default TrainingPage;
